import { render, staticRenderFns } from "./ButtonApp.vue?vue&type=template&id=1c773804&scoped=true&"
import script from "./ButtonApp.vue?vue&type=script&lang=js&"
export * from "./ButtonApp.vue?vue&type=script&lang=js&"
import style0 from "./ButtonApp.vue?vue&type=style&index=0&id=1c773804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c773804",
  null
  
)

export default component.exports